import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Container } from 'components/Containers/Containers'
import { tokens } from 'styling/tokens'

export const TrendsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 2rem;

  @media (max-width: 70rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const TrendCard = styled(Container)<{ $full?: boolean }>`
  ${(props) => props.$full && 'grid-column: 1 / -1;'}

  @media (max-width: 70rem) {
    grid-column: auto;
  }
`

export const SectionHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`

export const ViewDaysLink = styled(Link)`
  flex-shrink: 0;
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.accent.onDark};
  text-decoration: none;
  white-space: nowrap;
  transition: color ${tokens.motion.duration} ${tokens.motion.ease};

  &:hover {
    color: ${tokens.accent.base};
    text-decoration: underline;
  }
`

export const TrendLegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0.5rem 0 0 0;
`

export const TrendLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`

export const TrendLegendSwatch = styled.span<{ $color: string; $dashed?: boolean }>`
  width: ${(props) => (props.$dashed ? '1rem' : '0.5rem')};
  height: ${(props) => (props.$dashed ? '2px' : '0.5rem')};
  border-radius: ${(props) => (props.$dashed ? '0' : '50%')};
  background: ${(props) => (props.$dashed ? 'transparent' : props.$color)};
  ${(props) => props.$dashed && `border-top: 2px dashed ${props.$color};`}
`

export const StarvationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const StarvationRow = styled.div`
  display: grid;
  grid-template-columns: minmax(10rem, 14rem) 1fr;
  align-items: end;
  gap: 1rem;

  @media (max-width: 40rem) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const StarvationBars = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
`

export const StarvationWeekCol = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
`

export const StarvationTrack = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  height: 2.5rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  overflow: hidden;
`

export const StarvationFill = styled.div<{ $pct: number }>`
  width: 100%;
  height: ${(props) => props.$pct}%;
  background: ${tokens.status.warning.fg};
  opacity: 0.85;
`
